import { ReactComponent as GlobalIcon } from 'assets/icons/location/global.svg';
import { ReactComponent as LocationIcon } from 'assets/icons/location/location.svg';

export const location = {
  global: GlobalIcon,
  location: LocationIcon,
};
